import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { RevealOnMount } from "./seo/RevealOnMount";
import "@core/styles/index.css";
// Initialiser i18n (config core + namespace produit `polls`) avant le rendu.
import "./i18n";

// Initialiser le monitoring
import { initMonitoring } from "@core/lib/initMonitoring";
initMonitoring();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <RevealOnMount>
        <App />
      </RevealOnMount>
    </HelmetProvider>
  </React.StrictMode>,
);

// Enregistrement du service worker : requis par Chrome pour que le site
// soit "installable" et déclenche beforeinstallprompt (NAJ-108). Le SW lui-même
// ne fait rien (pas de fetch handler, cf. public/sw.js) — pas de cache offline.
if ("serviceWorker" in navigator) {
  if (import.meta.env.DEV) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  } else {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        // Best-effort : l'absence de SW dégrade seulement l'installabilité PWA.
      });
    });
  }
}
